;(function(){
   "use strict";

    let activeObject = null, _unitType = 'mm', _unitScale = 1, _activeSelection = null, _eleBBox = null,
    _realWidth, realHeight;

    function _getUserNumber(dim){
        var scale = Number(_unitScale),
            units = (_unitType=== 'inch') ? 0.039370 : 1;
        if(isNaN(dim) || dim === null) return dim;
        dim = Number(dim);
        return dim *= scale*units
    }

    function _getRealNumber(n){
        var scale = Number(_unitScale),
        units = (_unitType=== 'inch') ? 0.039370 : 1;
        if(isNaN(n) || n === null) return n;
        n = Number(n);
        return n /= scale*units
    }

    function _isDisabled(state){
        if(!_activeSelection) return true;
        return !state.x && !state.y && !state.width && !state.height ? true : null;
    }

    function _handleChange(state){
        return function(e){
            let x,y,width,height, rotation, obj;
            e.stopPropagation();
            if(_isDisabled(state)) return;
            switch(e.currentTarget.name){
                case 'width':
                case 'height':
                    obj = {type: e.currentTarget.name === "width" ? 'cr' : 'bc'};
                    obj[e.currentTarget.name] = _getRealNumber(e.currentTarget.value);
                    if(window.resizeSelection){
                        window.resizeSelection(obj.width || null, obj.height || null);
                    }else{
                        GS.Observer.dispatch('direct:resize',obj);
                    }
                    break;
                case 'x':
                case 'y':
                    x = e.currentTarget.name === 'x' ? e.currentTarget.value : null;
                    y = e.currentTarget.name === 'y' ? e.currentTarget.value : null;
                    let eBBox = document.getElementById('ele-bbox');

                    let correctX = !(x === null);
                    let correctY = !(y === null);

                    //console.debug('X: %s  Y: %s', x, y);

                    obj = {'x': _getRealNumber(x), 'y': _getRealNumber(y) };
                    if(window.moveSelection){
                        console.debug(state);


                        if(_eleBBox) {
                            if(correctX) obj.x += _eleBBox.width.baseVal.value*.5;
                            if(correctY) obj.y += _eleBBox.height.baseVal.value*.5;
                        }else{
                            if(correctX) obj.x += state.width*.5;
                            if(correctY) obj.y += state.height*.5;
                        }
                        window.moveSelection(obj.x, obj.y);
                    }else{
                        GS.Observer.dispatch('direct:move',obj);
                    }

                    break;
                case 'rotation':
                    if(_activeSelection) {
                        if(window.rotateSelection){
                            window.rotateSelection(e.currentTarget.value);
                        }else{
                            _activeSelection.setDirectRotation(e.currentTarget.value);
                        }

                    }
                break;
            }
        }
    }

    function _isReadOnly(_property){
        let r = null;
        switch(_property){
            case 'rotation':
                if(_activeSelection) r = _activeSelection.options.geometry.isLocked || _activeSelection.options.geometry.lockRotate;
                break;
            case 'move':
                if(_activeSelection) r = _activeSelection.options.geometry.isLocked || _activeSelection.options.geometry.lockMove;
                break;
            case 'resize':
                if(_activeSelection) r = _activeSelection.options.geometry.isLocked || _activeSelection.options.geometry.lockResize;
                break;
        }
        if(r === false) r = null;
        return r;
    }

    function _getNode(state){

        let x = state.x - state.width*.5;
        let y = state.y - state.height*.5;

        if(_eleBBox) {
            x = state.x - _eleBBox.width.baseVal.value*.5;
            y = state.y - _eleBBox.height.baseVal.value*.5;
        }

        return lighterhtml.html`
                    <div class="as-panel info-panel" disabled="${_isDisabled(state)}">
                        <div class="block">
                            
                                <div class="input-wrapper">
                                    <label>X:</label><input type="number" value="${_getUserNumber(x).toFixed(2)}" name="x" onchange="${_handleChange(state)}" readonly="${_isReadOnly('move')}">
                                </div>
                                <div class="input-wrapper">
                                    <label>Y:</label><input type="number" value="${_getUserNumber(y).toFixed(2)}" name="y" onchange="${_handleChange(state)}" readonly="${_isReadOnly('move')}">
                                </div>
                               
                           
                        </div>
                        <div class="block">
                            
                            <div class="input-wrapper">
                                <label>W:</label><input type="number" value="${_getUserNumber(state.width).toFixed(2)}" name="width" onchange="${_handleChange(state)}" readonly="${_isReadOnly('resize')}">
                            </div>
                            <div class="input-wrapper">
                                <label>H:</label><input type="number" value="${_getUserNumber(state.height).toFixed(2)}" name="height" onchange="${_handleChange(state)}" readonly="${_isReadOnly('resize')}">
                            </div>
                            
                        </div>
                        <div class="block">
                            <div class="input-wrapper">
                                <label>R°</label><input type="number" value="${state.rotation.toFixed(2)}" name="rotation" onchange="${_handleChange(state)}" readonly="${_isReadOnly('rotation')}">
                            </div>
                        </div>
                    </div>
                `;
    }

    function _update(state, parent){

        lighterhtml.render(parent, _getNode(state));
    }

   function _init(parent, unitType) {
       //console.info('ADD PANEL CONTENT INFO', parent);
       let defaultData =  {'x':0,'y':0,'rotation':0,'width':0, 'height': 0};
       let objectInfo = Object.assign({},(activeObject) ? activeObject.getData() : defaultData);

       if (window.GS.Observer) {

            function _check(obj){
               _activeSelection = obj;
               if(!_eleBBox) _eleBBox =  document.getElementById('ele-bbox');
               let data =  defaultData;
               try{
                   data = obj && obj.getData ? obj.getData() : defaultData;
                   if(data.type && data.type === 'background') data = defaultData;
                   if(window.getSpreadBookRealSizes) data.realSizes = window.getSpreadBookRealSizes();
               }catch(err){
                   data = defaultData;
               }
               data = Object.assign({},data);
               _update( data, parent);
               //console.info('@info:panel:check', data);
            }


           window.GS.Observer.register('active:frame', _check);
           window.GS.Observer.register('toolbar:force:show', _check);
           window.GS.Observer.register('no:selection', _check);


           window.GS.Observer.register('spread:new', function (obj) {
               //console.warn('SPREAD:NEW');
               _activeSelection = null;
               _update(defaultData, parent);

           });

           window.GS.Observer.register('object:info', function(obj){
               let data = defaultData;
               //console.info('@object:info', obj);
               if(obj && obj.ele && obj.ele.type !== 'background') data = obj.ele.getData();
               if(data.type && data.type === 'background') data = {};
               if(window.getSpreadBookRealSizes) data.realSizes = window.getSpreadBookRealSizes();
               objectInfo = data;
               _update( data, parent);
           })



           window.GS.Observer.register('info:panel:update', function(obj){
               if(obj && objectInfo){
                   objectInfo.x = Number(obj.x);
                   objectInfo.y = Number(obj.y);
                   objectInfo.width = Number(obj.width);
                   objectInfo.height = Number(obj.height);
                   objectInfo.rotation = Number(obj.rotation);
               }
               // console.info('@info:panel:update', obj);
               _update(  Object.assign({},objectInfo || defaultData), parent);
           })

           window.GS.Observer.register('display:info', function(type, obj){

                console.info('@display:info', obj);
              if(obj && objectInfo){
                  switch(type){
                      case 'position':
                          objectInfo.x = Number(obj.x);
                          objectInfo.y = Number(obj.y);
                          break;
                      case 'dimensions':
                          objectInfo.width = Number(obj.w || obj.width);
                          objectInfo.height = Number(obj.h || obj.height);
                          break;
                      case 'rotation':
                          objectInfo.rotation = Number(obj.a || obj.rotation);
                          break;
                  }

              }

               let data =  Object.assign({},objectInfo || defaultData);
               _update( data, parent);


           })
       }

       _update(objectInfo, parent);

       console.warn('INFO PANEL IS READY');

   }


   window.ObjectInfoPanel = function(parent, unitType, unitScale){

       let li = document.createElement('li');
       li.classList.add('info-panel');
       _unitType = unitType || 'mm';
       _unitScale = unitScale || 1;
       console.info('START INFO PANEL CLASS. UNIT: %s (SCALE: %s)', _unitType, _unitScale);
       parent.insertBefore(li, parent.firstChild);
       _init(li, unitType);

   }
}())